import { Typography } from "@mui/material";
import { ContentColumn } from "../../components/Content";

export default function Projects()
{
    return <ContentColumn>
        <Typography>Projects</Typography>
    </ContentColumn>
}